<template>
  <div>
    <div v-for="(work, w) in works" :key="'workTypes' + w" class="grid fw500">
      <div class="cell">{{ w + 1 }}</div>
      <div class="grid_inner">
        <div class="cell">
          {{
            work.is_hourly === 1
              ? $formatTime(getSum(work.reports, 'work_types'))
              : formatNumber(getSum(work.reports, 'work_types')) + ' ' + work.measure
          }}
        </div>
        <div class="cell">
          {{ work.name }}
        </div>
      </div>
    </div>
    <template v-if="extras.length > 0">
      <div class="grid fw500">
        <div class="cell">{{ works.length + 1 }}</div>
        <div class="grid_inner">
          <div class="cell">{{ $formatTime(getExtrasTotal()) }}</div>
          <div class="cell">{{ localStorage.translations.pages.finance['period-table']['total-extra'] }}</div>
        </div>
      </div>
      <div v-for="(extra, e) in extras" :key="'extras' + e" class="grid">
        <div class="cell">{{ works.length + 1 }}.{{ e + 1 }}</div>
        <div class="grid_inner">
          <div class="cell">{{ $formatTime(getSum(extra.reports, 'extras')) }}</div>
          <div class="cell">{{ extra.name }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "StatisticProjectReportsBlankConfirmTableTotal",
  props: {
    works: {
      type: Array,
      default: () => {
        return {}
      }
    },
    extras: {
      type: Array,
      default: () => {
        return {}
      }
    },
    confirmed: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: []
        }
      }
    },
  },
  methods: {
    getSum(items, type) {
      return Object.values(items).reduce((sum, current) => {
        if (this.confirmed[type] && this.confirmed[type].includes(current.id))
          return sum + current.approved_report
        else return sum
      }, 0)
    },
    getExtrasTotal() {
      let temp = 0
      for (let e in this.extras)
        temp += this.getSum(this.extras[e].reports, 'extras')
      return temp
    },
    formatNumber(num) {
      return Math.round(num * 100) / 100
    },
  }
}
</script>
